module.exports = __webpack_public_path__ + "media/images/home/concept_3_sp-4ecfc7bea5faa58b7706b2158a29fbd2.png";